// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardTcsWrapperModelsClaimAccumulatorModel {
    static getAttributeTypeMap() {
        return CardTcsWrapperModelsClaimAccumulatorModel.attributeTypeMap;
    }
}
CardTcsWrapperModelsClaimAccumulatorModel.discriminator = undefined;
CardTcsWrapperModelsClaimAccumulatorModel.additionalProperties = false;
CardTcsWrapperModelsClaimAccumulatorModel.attributeTypeMap = [
    {
        "name": "claims",
        "baseName": "claims",
        "type": ""
    },
    {
        "name": "medications",
        "baseName": "medications",
        "type": ""
    },
    {
        "name": "medicationMaxBenefit",
        "baseName": "medicationMaxBenefit",
        "type": "number"
    },
    {
        "name": "remainingMedicationBenefit",
        "baseName": "remainingMedicationBenefit",
        "type": "number"
    },
    {
        "name": "totalMedicationPaid",
        "baseName": "totalMedicationPaid",
        "type": "number"
    },
];
//# sourceMappingURL=cardTcsWrapperModelsClaimAccumulatorModel.js.map